import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = { style: {} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18",
  style: {}
}, "公開期間の設定", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "dgrey fs12 fw600" }, [
  /*#__PURE__*/_createTextVNode(" 日程を確定・提案できる日程を事前に指定します。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 指定した期間を過ぎた場合、自動的に日程が表示されなくなります。 ")
], -1)
const _hoisted_6 = { class: "fl mt20 text-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "ml3 mt10"
}
const _hoisted_9 = {
  class: "fl w60 mt20",
  style: {}
}
const _hoisted_10 = {
  class: "fl",
  style: {"width":"300px","margin-left":"80px"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "fs13 fl mt20" }, "に公開開始", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "fs13 fl mt20" }, "に公開終了", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "alertRed fs11 fw600"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.rcm.room_setting)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: _normalizeClass(`rad8 kakugo calendarfirst with_white_bg  ${_ctx.isSP ? 'pad20' : 'pad20'}`)
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_SelectTag, {
                class: "fl fs14 roundForm",
                style: {"min-width":"30px","height":"50px"},
                options: _ctx.SelectUtil.openPeriodTypes.map(mt => mt.name),
                optionName: `open_period_type`,
                defaultOption: _ctx.getDefaultOpenPeriodtype(),
                onSelectValue: _ctx.selectOpenPeriodType
              }, null, 8, ["options", "defaultOption", "onSelectValue"])
            ]),
            _hoisted_7,
            (![`none`, null].includes(_ctx.rcm.room_setting.open_period_type))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      ([`start_time_only`, `start_and_end_time`].includes(_ctx.rcm.room_setting.open_period_type))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_Dropdown, {
                              class: "mt10 form-group fl",
                              style: {"width":"140px"}
                            }, {
                              dropdown: _withCtx(() => [
                                _createElementVNode("li", null, [
                                  _createVNode(_component_date_picker, {
                                    modelValue: _ctx.startDate,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDate) = $event)),
                                    format: "yyyy/MM/dd"
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-control dropdown-toggle",
                                    type: "text",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.startDate]
                                  ])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_SelectTag, {
                              name: "meeting_start_time",
                              id: "select_meeting_start_time",
                              class: "fl fs14 roundForm noBorder mt3",
                              style: {"width":"90px","height":"50px"},
                              options: _ctx.timeArray,
                              defaultOption: _ctx.startTimeStr,
                              onSelectValue: _ctx.selectStartTime
                            }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                            _hoisted_13,
                            _hoisted_14
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_15,
                      ([`end_time_only`, `start_and_end_time`].includes(_ctx.rcm.room_setting.open_period_type))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_Dropdown, {
                              class: "mt10 form-group fl",
                              style: {"width":"140px"}
                            }, {
                              dropdown: _withCtx(() => [
                                _createElementVNode("li", null, [
                                  _createVNode(_component_date_picker, {
                                    modelValue: _ctx.endDate,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
                                    format: "yyyy/MM/dd"
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_17, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-control dropdown-toggle",
                                    type: "text",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDate) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.endDate]
                                  ])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_SelectTag, {
                              name: "meeting_end_time",
                              id: "select_meeting_start_time",
                              class: "fl fs14 roundForm noBorder mt3",
                              style: {"width":"90px","height":"50px"},
                              options: _ctx.timeArray,
                              defaultOption: _ctx.endTimeStr,
                              onSelectValue: _ctx.selectEndTime
                            }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                            _hoisted_18,
                            _hoisted_19
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_20,
                    (_ctx.errMsgSpan)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.errMsgSpan), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_22
        ], 2))
      : _createCommentVNode("", true)
  ]))
}